// TODO: This file appears to be unused dead code. The exported CutsheetParserExample
// component is never imported or rendered anywhere in the codebase. It looks like a
// dev/demo component that was never cleaned up. Verify it is safe to delete before removing.
import React from 'react';
import { gql, useMutation } from '@apollo/client';

/**
 * GraphQL mutation for parsing cutsheets
 */
export const PARSE_CUTSHEET = gql`
  mutation ParseCutsheet($file: Upload!) {
    parseCutsheet(file: $file) {
      catalog {
        name
        description
        animalType
        primals {
          title
          description
        }
        cuts {
          title
          description
          primalName
          pricePerPound
          priceFee
          priceFeePerPound
          minLbs
        }
        specifications {
          title
          description
          cutName
          options
        }
        trim {
          title
          description
          pricePerPound
          priceFee
          minLbs
        }
        extras {
          title
          description
          pricePerPound
          priceFee
          minLbs
        }
      }
      questionnaire {
        name
        description
        animalType
        questions {
          id
          type
          title
          description
          required
          sortOrder
          details
          imageUrl
          availableCutIds
          allowMultiple
          specificationId
          availableTrimIds
          requireExactTotal
        }
      }
    }
  }
`;

/**
 * Example usage component
 */
export function CutsheetParserExample() {
  const [parseCutsheet, { data, loading, error }] = useMutation(PARSE_CUTSHEET);

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;

    try {
      const result = await parseCutsheet({
        variables: { file },
      });

      if (result.data?.parseCutsheet) {
        const { catalog, questionnaire } = result.data.parseCutsheet;
        // You can now use this data to populate your cutsheet state
        // or questionnaire state in use-catalog-state.ts / use-questionnaire-state.ts
      }
    } catch (err) {
      // parse failure is handled by Apollo error state
    }
  };

  return (
    <div>
      <input
        type="file"
        accept=".pdf,.jpg,.jpeg,.png"
        onChange={handleFileUpload}
        disabled={loading}
      />
      {loading && <p>Parsing cutsheet...</p>}
      {error && <p>Error: {error.message}</p>}
      {data && (
        <div>
          <h3>Parsed Cutsheet: {data.parseCutsheet.catalog.name}</h3>
          <p>Primals: {data.parseCutsheet.catalog.primals.length}</p>
          <p>Cuts: {data.parseCutsheet.catalog.cuts.length}</p>
          <p>Questions: {data.parseCutsheet.questionnaire.questions.length}</p>
        </div>
      )}
    </div>
  );
}
